import { environment as base } from './environment.dev';

export const environment = {
    ...base,
    appId: 'ca.haleo.screener.dev',
};
